export default __webpack_public_path__ + "static/media/point-blue-new-theme.22a1e5bf.svg";